// extracted by mini-css-extract-plugin
module.exports = {"container":"VehicleSegmentsTab_container__PMhu6"};